import * as AppConstants from 'app/AppConstants';
import {fetchDataSourcesByCardId} from './dataSourceService';
import {selectDataSourceIdByCardId} from './dataSourceSelectors';

export const loadDataSourcesByCardId = (cardId) => (dispatch, getState) => {
  if (selectDataSourceIdByCardId(getState(), cardId)) return Promise.resolve();
  return fetchDataSourcesByCardId(cardId).then((response) => {
    const {dataSources} = response;

    dispatch({
      type: AppConstants.DATASOURCE__LOADED_BY_CARD_ID,
      payload: {
        cardId,
        dataSources,
        filterGroups: response.filterGroups,
      },
    });
  });
};
